import * as ACTION_TYPES from './actiontypes';

// multiselect
export const beginMultiselect = item => ({
  type: ACTION_TYPES.BEGIN_MULTISELECT,
  payload: {
    item
  }
});

export const endMultiselect = () => ({
  type: ACTION_TYPES.END_MULTISELECT
});

export const selectItemMultiselect = item => ({
  type: ACTION_TYPES.SELECT_ITEM_MULTISELECT,
  payload: {
    item
  }
});

export const deselectItemMultiselect = item => ({
  type: ACTION_TYPES.DESELECT_ITEM_MULTISELECT,
  payload: {
    item
  }
});

// add dx
export const addDxRequest = () => ({
  type: ACTION_TYPES.ADD_DX_REQUEST
});

export const addDxSuccess = listItems => ({
  type: ACTION_TYPES.ADD_DX_SUCCESS,
  payload: {
    listItems
  }
});

export const addDxFailure = error => ({
  type: ACTION_TYPES.ADD_DX_FAILURE,
  error
});

// approve dx
export const approveDxRequest = () => ({
  type: ACTION_TYPES.APPROVE_DX_REQUEST
});

export const approveDxSuccess = listItems => ({
  type: ACTION_TYPES.APPROVE_DX_SUCCESS,
  payload: {
    listItems
  }
});

export const approveDxFailure = error => ({
  type: ACTION_TYPES.APPROVE_DX_FAILURE,
  error
});

// unapprove dx
export const unapproveDxRequest = () => ({
  type: ACTION_TYPES.UNAPPROVE_DX_REQUEST
});

export const unapproveDxSuccess = listItems => ({
  type: ACTION_TYPES.UNAPPROVE_DX_SUCCESS,
  payload: {
    listItems
  }
});

export const unapproveDxFailure = error => ({
  type: ACTION_TYPES.UNAPPROVE_DX_FAILURE,
  error
});

// remove dx
export const removeDxRequest = () => ({
  type: ACTION_TYPES.REMOVE_DX_REQUEST
});

export const removeDxSuccess = listItems => ({
  type: ACTION_TYPES.REMOVE_DX_SUCCESS,
  payload: {
    listItems
  }
});

export const removeDxFailure = error => ({
  type: ACTION_TYPES.REMOVE_DX_FAILURE,
  error
});

// unremove dx
export const unremoveDxRequest = () => ({
  type: ACTION_TYPES.UNREMOVE_DX_REQUEST
});

export const unremoveDxSuccess = listItems => ({
  type: ACTION_TYPES.UNREMOVE_DX_SUCCESS,
  payload: {
    listItems
  }
});

export const unremoveDxFailure = error => ({
  type: ACTION_TYPES.UNREMOVE_DX_FAILURE,
  error
});

// hydrate dx list
export const hydrate = listItems => ({
  type: ACTION_TYPES.HYDRATE,
  payload: {
    listItems
  }
});
